import * as _ from "lodash";
export class Stat {
    public id: string | null = null;
    public canvasses = 0;
    public avg_reception = 0.0;
    public hitrate = 0;

    constructor(data?: any) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        _.merge(this, data);
    }

    getId(): string | null {
        return this.id;
    }
}
